module.exports = __webpack_public_path__ + "static/media/arrow_up.9ac029f7.svg";